import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/feature/Navbar";
import { Footer } from "./components/feature/Footer";
import { CartDrawer } from "./components/feature/CartDrawer";
import ScrollToTop from "./components/feature/ScrollToTop";
import { DiscountPopup } from "./components/feature/DiscountPopup";
import { ExitIntentPopup } from "./components/feature/ExitIntentPopup";
import { UrgencyBanner } from "./components/feature/UrgencyBanner";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CartProvider>
          <ScrollToTop />
          <UrgencyBanner />
          <Navbar />
          <AppRoutes />
          <Footer />
          <CartDrawer />
          <DiscountPopup />
          <ExitIntentPopup />
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
